import { afterUploadFileSuccess } from "../services/websiteApi";
import { isLastNameFirst } from "./nameOrder";

export const userInfoFetch = () => {
  const userIndex = sessionStorage.getItem("userIndex") || {};
  const userList = JSON.parse(sessionStorage.getItem("userList")) || {};
  return userList[userIndex];
};

//this is for passingReportId for ROM Module is reportId is exits and follow should be same
const passingReportId = () => {
  const status = sessionStorage.getItem("romStatus");
  const reportID = sessionStorage.getItem("romReportId");
  if (status === "success" && reportID) {
    return reportID;
  } else return undefined;
};
//This is for after file upload have to call this API to Run AI
export const fileUploadSuccessHandler = (
  seniorUuid,
  moduleId,
  uploadPath,
  subModuleid,
) => {
  const request = {
    endTime: -1,
    episodeId: "",
    moduleId: moduleId,
    recordingStatus: 4,
    seniorId: seniorUuid,
    startTime: -1,
    subModuleId: subModuleid,
    uploadPath: uploadPath,
    reportId: passingReportId(),
  };
  return afterUploadFileSuccess(seniorUuid, request);
};

export const formatName = (user, locale = "en") => {
  const first = user?.first_name ?? "";
  const last = user?.last_name ?? "";
  if (!first && !last) return user?.name ?? "";
  if (isLastNameFirst(locale)) return `${last} ${first}`.trim();
  return `${first} ${last}`.trim();
};

export const dateFormatHanlder = (date, locale = "en") => {
  const res = new Date(date);
  if (Number.isNaN(res.getTime())) return "";
  if (locale === "ja" || locale === "zh") {
    return `${res.getUTCFullYear()}年${res.getUTCMonth() + 1}月${res.getUTCDate()}日`;
  }
  if (!["en", "ja", "zh"].includes(locale)) {
    return res.toLocaleDateString(locale, {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "UTC",
    });
  }
  const month = res.toLocaleString(locale, {
    month: "long",
    timeZone: "UTC",
  });
  return month + " " + res.getUTCDate() + " " + res.getUTCFullYear();
};
